import Vue from 'vue'
import Router from 'vue-router'

// 登录页
import Login from '@/pages/Login'
// const Login = () => import('@/pages/Login')
// 权限页
const ErrorCode = () => import('@/pages/ErrorCode')
// 层级
const EntryA = () => import('@/pages/EntryA')
const EntryB = () => import('@/pages/EntryB')

// 1.首页
const DataOverview = () => import('@/pages/home/manage/DataOverview')
// 2. 机构
const MechanismIndex = () => import('@/pages/mechanism/manage/MechanismIndex')
const MechanismFrom = () => import('@/pages/mechanism/manage/MechanismFrom')
// 3. 校区
const CampusIndex = () => import('@/pages/campus/manage/CampusIndex')
const CampusFrom = () => import('@/pages/campus/manage/CampusFrom')
const ClassesIndex = () => import('@/pages/campus/manage/ClassesIndex')
const ClassesForm = () => import('@/pages/campus/manage/ClassesForm')

// 4. 版本
// const EditionIndex = () => import('@/pages/edition/manage/EditionIndex')
// const EditionFrom = () => import('@/pages/edition/manage/EditionFrom')
// const ModularIndex = () => import('@/pages/modular/manage/ModularIndex')
const UpgradeIndex = () => import('@/pages/upgrade/manage/UpgradeIndex')
const UpgradeForm = () => import('@/pages/upgrade/manage/UpgradeForm')
// 5. 设备
const DeviceIndex = () => import('@/pages/device/manage/DeviceIndex')
const DeviceFrom = () => import('@/pages/device/manage/DeviceFrom')
// 6. 激活码
const ActiveCodeIndex = () => import('@/pages/activeCode/manage/ActiveCodeIndex')
const ActiveCodeForm = () => import('@/pages/activeCode/manage/ActiveCodeForm')
const ActiveCodeBatch = () => import('@/pages/activeCode/manage/ActiveCodeBatch')
const StudentCodeIndex = () => import('@/pages/activeCode/manage/StudentCodeIndex')
const StudentCodeForm = () => import('@/pages/activeCode/manage/StudentCodeForm')
const StudentCodeBatch = () => import('@/pages/activeCode/manage/StudentCodeBatch')
// 7. 设置
const IndexFrom = () => import('@/pages/setting/manage/IndexFrom')
const IndexTwo = () => import('@/pages/setting/manage/IndexTwo')
const PersonalFrom = () => import('@/pages/setting/manage/PersonalFrom')
const PersonalTwo = () => import('@/pages/setting/manage/PersonalTwo')
const SetThrough = () => import('@/pages/setting/manage/SetThrough')
// 教师
const MemberIndex = () => import('@/pages/user/manage/MemberIndex')
const MemberFrom = () => import('@/pages/user/manage/MemberFrom')
const RecorRenewal = () => import('@/pages/user/manage/RecorRenewal')
// 学生管理
const StudentIndex = () => import('@/pages/user/manage/StudentIndex')
const StudentForm = () => import('@/pages/user/manage/StudentForm')
// 99.账号角色
const AdminIndex = () => import('@/pages/account/focus/AdminIndex')
const AdminForms = () => import('@/pages/account/focus/AdminForms')
const AdminLogs = () => import('@/pages/account/focus/AdminLogs')
const RecordIndex = () => import('@/pages/account/focus/RecordIndex')
const RoleIndex = () => import('@/pages/account/deploy/RoleIndex')
const RoleForms = () => import('@/pages/account/deploy/RoleForms')
const JournalIndex = () => import('@/pages/account/journal/JournalIndex')
// 套餐折扣管理
""
const ComboList = () => import('@/pages/comboDiscount/combo/ComboList')
const ComboForms = () => import('@/pages/comboDiscount/combo/ComboForms')
const DiscountList = () => import('@/pages/comboDiscount/discount/DiscountList')
const DiscountForms = () => import('@/pages/comboDiscount/discount/DiscountForms')

Vue.use(Router)
export default new Router({
  routes: [{
    path: '/',
    name: '/',
    component: Login,
    meta: { show: false, title: '登录页', display: false }
  },
  {
    // reject: '/Login',
    path: '/Login',
    name: 'Login',
    component: Login,
    meta: { show: false, title: '登录页', display: false }
  },
  {
    path: '/ErrorCode',
    name: 'ErrorCode',
    component: ErrorCode,
    meta: { show: false, title: '没有权限', display: false }
  },
  {
    path: '/home',
    name: 'home',
    component: EntryB,
    meta: { show: true, title: '首页', icon: 'icon-feather-airplay', active: '' },
    children: [{
      path: '/home/manage',
      name: 'HomeManage',
      component: EntryA,
      meta: { show: true, title: '数据展示', active: '' },
      children: [{
        path: '/home/manage/DataOverview',
        name: 'DataOverview',
        component: DataOverview,
        meta: { show: true, title: '数据统计', display: true, active: '', similar: 'Data' }
      }]
    }]
  },
  {
    path: '/mechanism',
    name: 'mechanism',
    component: EntryB,
    meta: {show: true, title: '机构', icon: 'icon-feather-codepen', active: ''},
    children: [{
      path: '/mechanism/manage',
      name: 'MechanismManage',
      component: EntryA,
      meta: {show: true, title: '列表管理', active: ''},
      children: [{
        path: '/mechanism/manage/MechanismIndex',
        name: 'MechanismIndex',
        component: MechanismIndex,
        meta: {show: true, title: '机构列表', display: true, active: '', similar: 'Mechanism'}
      }, {
        path: '/mechanism/manage/MechanismAdd',
        name: 'MechanismAdd',
        component: MechanismFrom,
        meta: {show: false, title: '新增机构', display: true, active: '', similar: 'Mechanism'}
      }, {
        path: '/mechanism/manage/MechanismEdit/:id',
        name: 'MechanismEdit',
        component: MechanismFrom,
        meta: {show: false, title: '编辑机构', display: true, active: '', similar: 'Mechanism'}
      }, {
        path: '/mechanism/manage/CampusIndex',
        name: 'CampusIndex',
        component: CampusIndex,
        meta: {show: true, title: '校区列表', display: true, active: '', similar: 'Campus'}
      }, {
        path: '/mechanism/manage/CampusAdd',
        name: 'CampusAdd',
        component: CampusFrom,
        meta: {show: false, title: '新增校区', display: true, active: '', similar: 'Campus'}
      }, {
        path: '/mechanism/manage/CampusEdit/:id',
        name: 'CampusEdit',
        component: CampusFrom,
        meta: {show: false, title: '编辑校区', display: true, active: '', similar: 'Campus'}
      }, {
        path: '/mechanism/manage/ClassesIndex',
        name: 'ClassesIndex',
        component: ClassesIndex,
        meta: {show: true, title: '班级列表', display: true, active: '', similar: 'Classes'}
      }, {
        path: '/mechanism/manage/ClassesAdd',
        name: 'ClassesAdd',
        component: ClassesForm,
        meta: {show: false, title: '新增班级', display: true, active: '', similar: 'Classes'}
      }, {
        path: '/mechanism/manage/ClassesEdit/:id',
        name: 'ClassesEdit',
        component: ClassesForm,
        meta: {show: false, title: '编辑班级', display: true, active: '', similar: 'Classes'}
      }]
    }]
  },
  {
    path: '/ComboDiscount',
    name: 'ComboDiscount',
    component: EntryB,
    meta: { show: true, title: '套餐折扣', icon: 'icon-feather-codepen', active: '' },
    children: [{
      path: '/ComboDiscount/manage',
      name: 'ComboDiscountManage',
      component: EntryA,
      meta: { show: true, title: '列表管理', active: '' },
      children: [{
        path: '/ComboDiscount/manage/Combo',
        name: 'Combo',
        component: ComboList,
        meta: {parent: 'ComboDiscount', title: '套餐管理', icon: '', show: true, display: true, menu: true}
      }, {
        path: '/ComboDiscount/manage/ComboEdit/:id',
        name: 'ComboEdit',
        component: ComboForms,
        meta: {parent: 'Combo', title: '套餐编辑', icon: '', show: false, display: true, menu: true}
      }, {
        path: '/ComboDiscount/manage/ComboAdd',
        name: 'ComboAdd',
        component: ComboForms,
        meta: {parent: 'Combo', title: '套餐新增', icon: '', show: false, display: true, menu: true}
      }, {
        path: '/ComboDiscount/manage/Discount',
        name: 'Discount',
        component: DiscountList,
        meta: {parent: 'ComboDiscount', title: '折扣管理', icon: '', show: true, display: true, menu: true}
      }, {
        path: '/ComboDiscount/manage/DiscountEdit/:id',
        name: 'DiscountEdit',
        component: DiscountForms,
        meta: {parent: 'Discount', title: '折扣编辑', icon: '', show: false, display: true, menu: true}
      }, {
        path: '/ComboDiscount/manage/DiscountAdd',
        name: 'DiscountAdd',
        component: DiscountForms,
        meta: {parent: 'Discount', title: '折扣新增', icon: '', show: false, display: true, menu: true}
      }]
    }]
  },
  // {
  //   path: '/campus',
  //   name: 'campus',
  //   component: EntryB,
  //   meta: {show: true, title: '校区', icon: 'icon-feather-command', active: ''},
  //   children: [{
  //     path: '/campus/manage',
  //     name: 'CampusManage',
  //     component: EntryA,
  //     meta: {show: true, title: '校区管理', active: ''},
  //     children: []
  //   }]
  // },
  {
    path: '/upgrade',
    name: 'upgrade',
    component: EntryB,
    meta: { show: true, title: '版本', icon: 'icon-feather-database', active: '' },
    children: [{
      path: '/upgrade/manage',
      name: 'UpgradeManage',
      component: EntryA,
      meta: { show: true, title: '版本管理', active: '' },
      children: [{
        path: '/upgrade/manage/UpgradeIndex',
        name: 'UpgradeIndex',
        component: UpgradeIndex,
        meta: { show: true, title: '版本列表', display: true, active: '', similar: 'Upgrade' }
      }, {
        path: '/upgrade/manage/UpgradeAdd',
        name: 'UpgradeAdd',
        component: UpgradeForm,
        meta: { show: false, title: '版本新增', display: true, active: '', similar: 'Upgrade' }
      }, {
        path: '/upgrade/manage/UpgradeEdit/:id',
        name: 'UpgradeEdit',
        component: UpgradeForm,
        meta: { show: false, title: '版本编辑', display: true, active: '', similar: 'Upgrade' }
      }]
    }]
  },
  {
    path: '/device',
    name: 'device',
    component: EntryB,
    meta: { show: true, title: '设备', icon: 'icon-feather-smartphone', active: '' },
    children: [{
      path: '/device/manage',
      name: 'DeviceManage',
      component: EntryA,
      meta: { show: true, title: '设备管理', active: '' },
      children: [{
        path: '/device/manage/DeviceIndex',
        name: 'DeviceIndex',
        component: DeviceIndex,
        meta: { show: true, title: '设备列表', display: true, active: '', similar: 'Device' }
      }, {
        path: '/device/manage/DeviceAdd',
        name: 'DeviceAdd',
        component: DeviceFrom,
        meta: { show: false, title: '新增设备', display: true, active: '', similar: 'Device' }
      }, {
        path: '/device/manage/DeviceEdit/:id',
        name: 'DeviceEdit',
        component: DeviceFrom,
        meta: { show: false, title: '编辑设备', display: true, active: '', similar: 'Device' }
      }]
    }]
  },
  // {
  //   path: '/activeCode',
  //   name: 'activeCode',
  //   component: EntryB,
  //   meta: { show: true, title: '激活码', icon: 'icon-feather-paperclip', active: '' },
  //   children: [{
  //     path: '/activeCode/manage',
  //     name: 'ActiveCodeManage',
  //     component: EntryA,
  //     meta: { show: true, title: '激活码管理', active: '' },
  //     children: [{
  //       path: '/activeCode/manage/ActiveCodeIndex',
  //       name: 'ActiveCodeIndex',
  //       component: ActiveCodeIndex,
  //       meta: { show: true, title: '激活码列表', display: true, active: '', similar: 'ActiveCode' }
  //     }, {
  //       path: '/activeCode/manage/ActiveCodeAdd',
  //       name: 'ActiveCodeAdd',
  //       component: ActiveCodeForm,
  //       meta: { show: false, title: '新增激活码', display: true, active: '', similar: 'ActiveCode' }
  //     }, {
  //       path: '/activeCode/manage/ActiveCodeEdit/:id',
  //       name: 'ActiveCodeEdit',
  //       component: ActiveCodeForm,
  //       meta: { show: false, title: '编辑激活码', display: true, active: '', similar: 'ActiveCode' }
  //     }, {
  //       path: '/activeCode/manage/ActiveCodeBatch',
  //       name: 'ActiveCodeBatch',
  //       component: ActiveCodeBatch,
  //       meta: { show: false, title: '批量新增激活码', display: true, active: '', similar: 'ActiveCode' }
  //     }, {
  //       path: '/activeCode/manage/StudentCodeIndex',
  //       name: 'StudentCodeIndex',
  //       component: StudentCodeIndex,
  //       meta: { show: true, title: '学生激活码', display: true, active: '', similar: 'StudentCode' }
  //     }, {
  //       path: '/activeCode/manage/StudentCodeAdd',
  //       name: 'StudentCodeAdd',
  //       component: StudentCodeForm,
  //       meta: { show: false, title: '新增学生激活码', display: true, active: '', similar: 'StudentCode' }
  //     }, {
  //       path: '/activeCode/manage/StudentCodeEdit/:id',
  //       name: 'StudentCodeEdit',
  //       component: StudentCodeForm,
  //       meta: { show: false, title: '编辑学生激活码', display: true, active: '', similar: 'StudentCode' }
  //     }, {
  //       path: '/activeCode/manage/StudentCodeBatch',
  //       name: 'StudentCodeBatch',
  //       component: StudentCodeBatch,
  //       meta: { show: false, title: '批量新增学生激活码', display: true, active: '', similar: 'StudentCode' }
  //     }]
  //   }]
  // },
  {
    path: '/setting',
    name: 'setting',
    component: EntryB,
    meta: { show: true, title: '设置', icon: 'icon-feather-settings', active: '' },
    children: [{
      path: '/setting/manage',
      name: 'SettingManage',
      component: EntryA,
      meta: { show: true, title: '设置管理', active: '' },
      children: [{
        path: '/setting/manage/IndexFrom',
        name: 'IndexFrom',
        component: IndexFrom,
        meta: { show: true, title: '首页设置', display: true, active: '', similar: 'IndexFrom' }
      }, {
        path: '/setting/manage/IndexTwo',
        name: 'IndexTwo',
        component: IndexTwo,
        meta: { show: true, title: '首页设置2', display: true, active: '', similar: 'IndexTwo' }
      }, {
        path: '/setting/manage/PersonalFrom',
        name: 'PersonalFrom',
        component: PersonalFrom,
        meta: { show: true, title: '个人设置', display: true, active: '', similar: 'PersonalFrom' }
      }, {
        path: '/setting/manage/PersonalTwo',
        name: 'PersonalTwo',
        component: PersonalTwo,
        meta: { show: true, title: '个人设置2', display: true, active: '', similar: 'PersonalTwo' }
      }, {
        path: '/setting/manage/SetThrough',
        name: 'SetThrough',
        component: SetThrough,
        meta: { show: true, title: '闯关设置', display: true, active: '', similar: 'SetThrough' }
      }]
    }]
  },
  {
    path: '/user',
    name: 'user',
    component: EntryB,
    meta: { show: true, title: '会员', icon: 'icon-feather-user', active: '' },
    children: [{
      path: '/user/manage',
      name: 'UserManage',
      component: EntryA,
      meta: { show: true, title: '会员管理', active: '' },
      children: [{
        path: '/user/manage/MemberIndex',
        name: 'MemberIndex',
        component: MemberIndex,
        meta: { show: true, title: '教师列表', display: true, active: '', similar: 'Member' }
      }, {
        path: '/user/manage/MemberAdd',
        name: 'MemberAdd',
        component: MemberFrom,
        meta: { show: false, title: '教师新增', display: true, active: '', similar: 'Member' }
      }, {
        path: '/user/manage/MemberEdit/:id',
        name: 'MemberEdit',
        component: MemberFrom,
        meta: { show: false, title: '教师编辑', display: true, active: '', similar: 'Member' }
      }, {
        path: '/user/manage/RecorRenewal/:id',
        name: 'RecorRenewal',
        component: RecorRenewal,
        meta: { show: false, title: '教师续费记录', display: true, active: '', similar: 'Member' }
      }, {
        path: '/user/manage/StudentIndex',
        name: 'StudentIndex',
        component: StudentIndex,
        meta: { show: true, title: '学生列表', display: true, active: '', similar: 'Student' }
      }, {
        path: '/user/manage/StudentAdd',
        name: 'StudentAdd',
        component: StudentForm,
        meta: { show: false, title: '学生新增', display: true, active: '', similar: 'Student' }
      }, {
        path: '/user/manage/StudentEdit/:id',
        name: 'StudentEdit',
        component: StudentForm,
        meta: { show: false, title: '学生编辑', display: true, active: '', similar: 'Student' }
      }]
    }]
  },
  {
    path: '/account',
    name: 'account',
    component: EntryB,
    meta: { show: true, title: '账号', icon: 'icon-feather-slack', active: '' },
    children: [{
      path: '/account/focus',
      name: 'focus',
      component: EntryA,
      meta: { show: true, title: '管理员', active: '' },
      children: [{
        path: '/account/focus/AdminIndex',
        name: 'AdminIndex',
        component: AdminIndex,
        meta: { show: true, title: '管理员列表', display: true, active: '', similar: 'Admin' }
      }, {
        path: '/account/focus/AdminAdd',
        name: 'AdminAdd',
        component: AdminForms,
        meta: { show: false, title: '新增管理员', display: true, active: '', similar: 'Admin' }
      }, {
        path: '/account/focus/AdminEdit/:id',
        name: 'AdminEdit',
        component: AdminForms,
        meta: { show: false, title: '编辑管理员', display: true, active: '', similar: 'Admin' }
      }, {
        path: '/account/focus/AdminLogs/:id',
        name: 'AdminLogs',
        component: AdminLogs,
        meta: { show: false, title: '管理员日志', display: true, active: '', similar: 'Admin' }
      }, {
        path: '/account/focus/RecordIndex',
        name: 'RecordIndex',
        component: RecordIndex,
        meta: { show: true, title: '操作日志', display: true, active: '', similar: 'Record' }
      }]
    }, {
      path: '/account/deploy',
      name: 'deploy',
      component: EntryA,
      meta: { show: true, title: '角色权限', active: '' },
      children: [{
        path: '/account/deploy/RoleIndex',
        name: 'RoleIndex',
        component: RoleIndex,
        meta: { show: true, title: '角色列表', display: true, active: '', similar: 'Role' }
      }, {
        path: '/account/deploy/RoleAdd',
        name: 'RoleAdd',
        component: RoleForms,
        meta: { show: false, title: '新增角色', display: true, active: '', similar: 'Role' }
      }, {
        path: '/account/deploy/RoleEdit/:id',
        name: 'RoleEdit',
        component: RoleForms,
        meta: { show: false, title: '编辑角色', display: true, active: '', similar: 'Role' }
      }]
    }, {
      path: '/account/journal',
      name: 'journal',
      component: EntryA,
      meta: { show: true, title: '导入日志', active: '' },
      children: [{
        path: '/account/journal/JournalIndex',
        name: 'JournalIndex',
        component: JournalIndex,
        meta: { show: true, title: '日志列表', display: true, active: '', similar: 'Journal' }
      }]
    }]
  }],
  scrollBehavior (to, form, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js